import { render } from "./Contact.vue?vue&type=template&id=4012bfda&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=4012bfda&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4012bfda"

export default script